
import React from "react";
import BookingForm from "../components/BookingForm";

const OranjevilleSelfCatering = () => {
    return (
        <div className="bg-[#F2F1F0] text-[#144E73] font-sans min-h-screen pt-16 pb-20 px-6">
            <div className="max-w-6xl mx-auto">
                {/* Title */}
                <h1 className="text-4xl md:text-5xl font-bold text-primarymb-10 text-center">
                    Oranjeville Self-Catering
                </h1>

                {/* Gallery + Description */}
                <div className="grid md:grid-cols-2 gap-10 mb-16 items-start">
                    {/* Gallery */}
                    <div className="grid grid-rows-[auto_1fr] gap-4">
                        <img
                            src="/images/oranjeville/first-image.jpg"
                            alt="Oranjeville SC Main"
                            className="rounded-lg aspect-[16/9] object-cover border-4 border-[#FEB339]"
                        />
                        <div className="grid grid-cols-2 gap-4">
                            {[...Array(6)].map((_, i) => (
                                <img
                                    key={i}
                                    src={`/images/oranjeville/image-${i + 1}.png`}
                                    alt={`Oranjeville Gallery ${i + 1}`}
                                    className="rounded-lg aspect-[4/3] object-cover border-4 border-[#FEB339]"
                                />
                            ))}
                        </div>
                    </div>

                    {/* Description */}
                    <div>
                        <p className="text-lg leading-relaxed mb-4">
                            Oranjeville Self-Catering offers relaxed, comfortable self-catering accommodation just a short walk from the town and Vaal Dam. Ideal for families or groups, each apartment is spacious and well-equipped.
                        </p>
                        <ul className="list-disc ml-5 text-sm space-y-2">
                            <li>4× 3-bedroom apartments (sleeps 6 each)</li>
                            <li>Shaded parking available</li>
                            <li>Short walk to shops and restaurants</li>
                            <li>Ideal for fishing weekends or group stays</li>
                            <li>Peaceful setting near the water</li>
                        </ul>

                      
                    </div>
                </div>



                {/* Booking Form */}

                <BookingForm  hotelName="Oranjeville Self-Catering" />


            </div>
        </div>
    );
};

export default OranjevilleSelfCatering;
